







































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddPresentation from '@/components/Admin/Panels/AddPresentation.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import VacantUnitData from '@/ts/VacantUnitData';
import { dateFormat } from '@/ts/DefaultTableConfigs';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        AddPresentation,
        FlexibleTable,
    },
    computed: {
        ...mapGetters({
            addPresentationVisibility: 'PresentationFlows/getAddPresentationVisibility',
        }),
    },
})
export default class VacantUnits extends Vue {
    public tableEntity: string = 'VacantUnits';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'name', label: this.$t('general.unit-id', 'Unit ID'), align: 'left', field: 'name', sortable: true, required: false },
            { name: 'project', label: this.$t('general.project', 'Project'), align: 'left', field: 'project', sortable: true, required: true },
            { name: 'availableFrom', label: this.$t('general.available-from', 'Available from'), align: 'left', field: 'availableFrom', sortable: true, required: false, filterType: 'date', dateFormat },
            { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true, required: false },
            { name: 'type', label: this.$t('general.type', 'Type'), align: 'left', field: 'type', sortable: true, required: false },
            { name: 'groups', label: this.$t('general.groupings', 'Groups'), align: 'left', field: 'groups', sortable: true, required: false, filterType: 'array' },
            { name: 'offers', label: this.$t('general.offers', 'Offers'), align: 'left', sortable: false, required: false, filter: false, html: true,
                field: (row: any) => {
                    let offers = '<span style="white-space: pre-line">';

                    for (const p of row.activePresentations) {
                        offers += `#${p.id} - ${this.$t('waiting-list.' + p.status, p.status)} \n`;
                    }

                    offers += '</span>';

                    return offers;
                },
            },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'project',
                'availableFrom',
                'address',
                'groups',
                'unitType',
            ],
        };
    }

    get vacantUnits(): VacantUnitData[] {
        return this.$store.getters['PresentationFlows/getVacantUnits'];
    }

    public addPresentationModal(unitId: number) {
        this.$store.dispatch(Actions.FETCH_CURRENT_VACANT_UNIT, unitId);
    }

    public goToUnit(propertyId: number) {
        this.$router.push({ name: 'admin-units', params: { unitId: propertyId.toString() }});
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_VACANT_UNITS, {
            project: this.$store.getters['PresentationFlows/getCurrentProject'],
        });
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.SET_ADD_PRESENTATION_VISIBILITY, false);
        this.$store.commit(Mutations.SET_CURRENT_VACANT_UNIT_ADD, []);
    }
}
